export default "__VITE_ASSET__7f029135__"